import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalDealInfoInterface } from '../../interfaces';

@Component({
  selector: 'app-hover-modal',
  templateUrl: './hover-modal.component.html',
  styleUrls: ['./hover-modal.component.scss'],
})
export class HoverModalComponent {
  constructor(
    public dialogRef: MatDialogRef<HoverModalComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: ModalDealInfoInterface,
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
